import { render, staticRenderFns } from "./activityLog.vue.html?vue&type=template&id=56244548"
import script from "./activityLog.controller?vue&type=script&lang=js&external"
export * from "./activityLog.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports